import { z } from "zod";

export const mongoObjectId = (description?: string, errmsg?: string) =>
  z
    .string({
      description,
      ...(errmsg != null ? { required_error: errmsg } : {}),
    })
    .regex(/^[0-9a-f]{24}$/, errmsg);
